import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9a3e3476&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a3e3476"]])

export default __exports__